// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAZYz_DbLwettvtc95MTPm3qrYtDtnyTW0",
  authDomain: "video11-7e3b7.firebaseapp.com",
  projectId: "video11-7e3b7",
  storageBucket: "video11-7e3b7.firebasestorage.app",
  messagingSenderId: "660254205302",
  appId: "1:660254205302:web:fbc7432383a4e980d9c657",
  measurementId: "G-KQ62MSP2HY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
